<script lang="ts" setup>
import type { SeoMetaTagType } from "vue-datocms";
import type { HeaderSectionRecord, TrendsInspirationRecord } from "~~/server/graphql/datocms/generated";
import { toHead } from "vue-datocms";

const { locale } = useI18n();
const { params } = useRoute();
const slug = params.slug || "home";

const { data } = await useFetch<TrendsInspirationRecord>("/api/cms/trends/detail", {
  query: { slug: slug, locale: locale },
});

if (!data.value) {
  throw create404Error();
}

// logged an issue - keeping code here until resolved
// https://github.com/nuxt-modules/i18n/issues/2685
// // console.log(data.value._allSlugLocales?.map(locale => locale.locale?.replace("_", "-").toLocaleLowerCase()));
// // false && /*#__PURE__*/ defineI18nRoute({
// //   locales: data.value._allSlugLocales?.map(locale => locale.locale?.replace("_", "-").toLocaleLowerCase()),
// // });
// // useDatoSlugsToI18n(data.value._allSlugLocales);
// defineI18nRoute({
//   locales: ["nl-be"],
// });
// // defineI18nRoute(false);
// const setI18nParams = useSetI18nParams();
// setI18nParams({
//   "nl-be": { slug: "dit-is-een-slug" },
//   "fr-be": { slug: null }, // I don't to localize this page in French
// });

// const switchLocalePath = useSwitchLocalePath();
// console.log("nl-be", switchLocalePath("nl-be"));
// console.log("fr-be", switchLocalePath("fr-be"));

useDatoSlugsToI18n(data.value._allSlugLocales!);

useHead(() => {
  if (!data.value) {
    return {};
  }

  return toHead(data.value._seoMetaTags as Array<SeoMetaTagType>);
});

const headerSection = computed(() => {
  return data.value?.sections.find(s => s.__typename === "HeaderSectionRecord") as HeaderSectionRecord;
});

const bodySections = computed(() => {
  return data.value?.sections.filter(s => s.__typename !== "HeaderSectionRecord");
});
</script>

<template>
  <div class="mt-3xl">
    <Breadcrumbs class="mb-sm" :page="data" page-type="trends" />

    <article v-if="data">
      <div v-if="headerSection" class="header-section">
        <SectionsHeader :data="headerSection" :page-title="data.title" :current-page-id="data.id" />
      </div>

      <div class="mb-xl flex justify-center">
        <div class="w-full lg:w-3/5">
          <h1 class="header-section__title mb-lg mt-3xl md:mb-xl text-left md:text-center">
            {{ data.title }}
          </h1>

          <div class="mb-lg flex justify-between">
            <span class="text-primary underline">
              {{ data.tags?.at(0)?.tag }}
            </span>
            <div>{{ new Date(data._publishedAt!).toLocaleDateString(locale, { year: "numeric", month: "long", day: "numeric" }) }}</div>
          </div>

          <hr class="border-neutral-100">
        </div>
      </div>

      <SectionsRenderer :sections="bodySections" :page-title="data.title" :current-page-id="data.id" />
    </article>
  </div>
</template>

<style>
article:has(.header-section img) {
  .header-section__title {
    display: none;
  }
}
</style>
